import { render } from "./MainCreditNoteSale.vue?vue&type=template&id=695fad8e&scoped=true"
import script from "./MainCreditNoteSale.vue?vue&type=script&lang=js"
export * from "./MainCreditNoteSale.vue?vue&type=script&lang=js"

import "./MainCreditNoteSale.vue?vue&type=style&index=0&id=695fad8e&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\front-api\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-695fad8e"]])

export default __exports__